// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"pZ-z","subtitle":"qZ-z","wrapper":"rZ-z","leftArrow":"sZ-z","rightArrow":"tZ-z"};